import { useContext } from "react";
import { ErrorDialogContext, errorHandledAsync } from "@/shared/context/error-context";
import { PutUsersService } from "@/features/user/services/put-users-service";


export const usePutUsers = () => {
  const putUsersService = new PutUsersService();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  const putUsers = async (soriId: string) => {
    try {
      await putUsersService.putUsers({
        sori_id: soriId,
      });
    } catch (error) {
      // エラー
      console.log("putUsers", error);
      throw error;
    } finally {
      //
    }
  };

  return {
    putUsers: errorHandledAsync(putUsers, setError),
  };
};
